import { Component } from "@angular/core";

@Component({
  selector: "icon-compensacion-mujeres-chart",
  templateUrl: "./compensacion-mujeres-chart.svg",
  styles: [`
    :host {
      display: block;
    }

    svg {
      display: block;
      width: 100%;
      height: auto;
    }
  `],
  standalone: true,
})
export class CompensacionMujeresChartComponent {}
